import { useEffect } from 'react';
import tracking from 'dibs-tracking';
import { getAbTestTrackingData } from 'dibs-buyer-layout/exports/clientABTestHelpers';
import { pageTypeConstants as pageTypes } from '../constants/pageTypeConstants';

export function useTileAbTestTracking() {
    useEffect(() => {
        const trackingData = getAbTestTrackingData(document.cookie, 'SB_TILE_TEST_VARIANT');
        tracking.trackAbTestEvent(trackingData, pageTypes.BROWSE);
    }, []);
}
